<app-wild-header></app-wild-header>
<app-useractivitydetailsshared [userId]="userId" [activityId]="activityId"></app-useractivitydetailsshared>
<app-footer></app-footer>